import Swiper from "swiper";
import { type0Breakpoints as breakpoints } from "../utils/breakpoints";

function handleTabClick(e) {
    e.preventDefault();

    const $navRoot = $(this).closest(".page-menu");
    const $relatedSlider = $($navRoot.data("slider"));
    const selectedTabId = $(this).data("tab-id");
    const swiper = $relatedSlider.data("swiper");

    // start animation
    const $tabPane = $relatedSlider.closest(".tab-pane");
    $tabPane.removeClass("show");

    // finish animation
    setTimeout(() => {
        // set current tab
        $navRoot.find(".nav-link").removeClass("active");
        $(this).addClass("active");

        // hide/show slides
        const $allSlides = $relatedSlider.find(".swiper-slide");
        const $selectedSlides =
            selectedTabId === 0
                ? $allSlides
                : $allSlides.filter(`[data-belongs-to='tab-${selectedTabId}']`);

        $allSlides.not($selectedSlides).addClass("d-none");
        $selectedSlides.removeClass("d-none");

        // reset swiper
        swiper.slideTo(0, 0);
        swiper.update();

        $tabPane.addClass("show");
    }, 150);
}

$(function () {
    $(".slider-products").each(function () {
        const swiper = new Swiper($(this).find(".swiper")[0], {
            slidesPerView: "auto",
            centeredSlides: true,
            centeredSlidesBounds: true,
            breakpoints,
        });

        $(this).data("swiper", swiper);
    });

    $(document).on(
        "click",
        ".js-slider-products-filter .nav-link",
        handleTabClick
    );
});
